<template>
  <div class="record">
    <div class="header">
      <peopleHeader></peopleHeader>
    </div>
    <div class="content">
      <VShowCell typeIcon="A" title="我的信息">
          <p class="two">通知</p>
          <p class="two" v-text="record"></p>
        </VShowCell>
      <div class="message">
        <!-- <work-item v-for="(item,index) in todoList"
                   :index="parseInt(index + 1)" 
                   :title="item.title"
                   :key="index"
                   :finished="item.status === 1"></work-item> -->
      </div>
    </div>
  </div>

</template>

<script>
  import peopleHeader from '../components/peopleHeader';
  import VShowCell from '../components/VShowCell';
  import WorkItem from '../components/WorkItem';
  import CardView from '../components/CardView';
  import Teacher from '../api/teacher';
  export default{
    name: 'teacher-info',
    activated() {
      this.getMessage();
    },
    data() {
      return {
        record: '',
        // todoList: [
          // {
          //   title:'啦啦啦',
          //   status:1
          // },
          // {
          //   title:'嘿嘿嘿',
          //   status:0
          // },
          
        // ],
      };
    },
    methods: {
      getMessage() {
        // Teacher.getTeacherProfileInfo().then(response => {
        //   if (response.errno === '0') {
        //     if (response.result.message) {
        //       this.record = response.result.message;
        //     }
        //     this.todoList = response.result.working_state;
        //   } else {}
        // }).catch(e => {
//          console.log(e);
            // result:{
            //   message:'通知',
            //   working_state:{
            //     title:'标题',
            //     status:1
            //   }
            // }
        // });
      }
    },
    components: {
      peopleHeader,
      VShowCell,
      CardView,
      WorkItem
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .record {
    @include bg-img('../assets/img/common/parentbgbase');
    position: relative;
    left: px2rem(27);
    width: px2rem(704);
    top: px2rem(128);
    height: px2rem(1004);
  }
  .message{
    height: px2rem(500);
    overflow-y: auto;
    overflow-x: hidden;
    margin: 0 px2rem(5) 0 px2rem(5);
    -webkit-overflow-scrolling: touch;
  }
  .header {
    left: px2rem(-20);
    top: px2rem(-50);
  }

  .two {
    line-height: px2rem(41);
    font-size: px2rem(23);
    color: rgba(123, 74, 0, 1);
  }

  .unfinished {
    width: px2rem(602);
    height: px2rem(115);
    margin: px2rem(10) auto 0 auto;
    color: white;
    @include bg-img('../assets/img/teacher/unfinish_bg');

    .icon {
      display: inline-block;
      height: px2rem(96);
      width: px2rem(69);
      vertical-align: top;
      color: white;
      line-height: px2rem(96);
      text-align: center;
      font-size: px2rem(45);
      @include bg-img('../assets/img/teacher/number_bg');
    }

    .title {
      height: px2rem(115);
      line-height: px2rem(115);
      font-size: px2rem(38);

      font-weight: bold;
    }
  }

  .finished {
    color: #6f4709;
    @include bg-img('../assets/img/teacher/finish_bg');

    .complete {
      @include bg-img('../assets/img/teacher/completed');
    }
  }


</style>



// WEBPACK FOOTER //
// TeacherInfo.vue?66233084